import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import * as Msal from '@azure/msal-browser';

interface AuthenticationService {
  logout(): Promise<void>;
  getUser(): Promise<Msal.AccountInfo | undefined>;
}

interface Dependencies {
  getFromApi: (url: string) => Promise<{data: any}>
  authenticationService: AuthenticationService;
}

export const buildUserModule = ({ getFromApi, authenticationService }: Dependencies) => {
  @Module({
    namespaced: true
  })
  class UserModule extends VuexModule {
    private auth = authenticationService;
    private _username?: string = undefined;
    private isExternal?: boolean = undefined;
    private userGroups?: Array<string> = [];
    private userGroupRole?: string = undefined;
    private userRole?: string = undefined;

    @Action
    public logout() {
      this.auth.logout();
    }

    @Action({ rawError: true })
    public async loadUser() {
      const user = await this.auth.getUser();
      this.context.commit('setUserName', user?.username);
      const { data } = await getFromApi('/user/getCurrentUserInfo');
      this.context.commit('setIsExternal', data?.isExternal);
      this.context.commit('setUserGroups', data?.groups);
      this.context.commit('setUserGroupRole', data?.groupRole);
      this.context.commit('setUserRole', data?.role);
    }

    @Mutation
    private setUserName(username: string) {
      this._username = username;
    }

    @Mutation
    private setUserRole(userrole: string) {
      this.userRole = userrole;
    }

    @Mutation
    private setIsExternal(isExternal: boolean) {
      this.isExternal = isExternal;
    }

    @Mutation
    private setUserGroups(userGroups: Array<string>) {
      this.userGroups = userGroups;
    }

    @Mutation
    private setUserGroupRole(userGroupRole: string) {
      this.userGroupRole = userGroupRole;
    }

    public get username() {
      return this._username;
    }

    public get getUserRole() {
      return this.userRole;
    }

    public get getIsExternal() {
      return this.isExternal;
    }

    public get getUserGroups() {
      return this.userGroups;
    }

    public get getUserGroupRole() {
      return this.userGroupRole;
    }
  }

  return UserModule;
};
